// extracted by mini-css-extract-plugin
export default {"general":"Paginated_general__5iTud","ul":"Paginated_ul__ZVQKN","list":"Paginated_list__a4yz0","btn":"Paginated_btn__ArFnQ","bn":"Paginated_bn__Wv-sT"};